import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_WIDTH = 97;
const DEFAULT_HEIGHT = 118;

const Banner = ({
  width,
  height,
  backgroundColor = '#FACF36',
  foregroundColor = '#ffffff',
  children,
}) => {
  /*
   * In order for our badges to look consistently good at different sizes
   * we're forcing the aspect ratio based on which dimension is passed in.
   * If both are passed in, we're preferring height.
   */
  let adjustedWidth;
  let adjustedHeight;
  if (height) {
    let parsedHeight = height;
    if (typeof height === 'string') {
      [parsedHeight] = height.match(/\d+/);
    }
    adjustedHeight = parsedHeight;
    adjustedWidth = (DEFAULT_WIDTH / DEFAULT_HEIGHT) * parsedHeight;
  } else if (width) {
    let parsedWidth = width;
    if (typeof width === 'string') {
      [parsedWidth] = width.match(/\d+/);
    }
    adjustedWidth = parsedWidth;
    adjustedHeight = (DEFAULT_HEIGHT / DEFAULT_WIDTH) * parsedWidth;
  } else {
    adjustedWidth = DEFAULT_WIDTH;
    adjustedHeight = DEFAULT_HEIGHT;
  }
  return (
    <svg
      width={`${adjustedWidth}px`}
      height={`${adjustedHeight}px`}
      viewBox="0 0 97 118"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <path
          d="M1.8772425,4.42903758 C16.6916453,1.47634586 31.3290482,-2.48689958e-14 45.7894511,-2.48689958e-14 C60.2379675,-2.48689958e-14 74.6858342,1.47391973 89.1330512,4.42175918 C90.2195835,4.64335343 91,5.59908766 91,6.70798639 L91,85.1318125 C91,85.976076 90.5439395,86.7544868 89.8074603,87.167257 L46.6407937,111.360626 C45.9321219,111.757811 45.0678781,111.757811 44.3592063,111.360626 L1.19253967,87.167257 C0.456060479,86.7544868 0,85.976076 0,85.1318125 L0,6.71736089 C0,5.60452517 0.785873197,4.64656083 1.8772425,4.42903758 Z"
          id="badge-banner"
        />
        <filter
          x="-4.9%"
          y="-4.0%"
          width="109.9%"
          height="108.1%"
          filterUnits="objectBoundingBox"
          id="filter-3"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.160784314   0 0 0 0 0.160784314   0 0 0 0 0.2  0 0 0 0.2 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard-Copy-3" transform="translate(-312.000000, -19.000000)">
          <g id="Group-6-Copy-40" transform="translate(315.000000, 22.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#badge-banner" />
            </mask>
            <g id="Rectangle-Copy-36">
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-3)"
                xlinkHref="#badge-banner"
              />
              <use
                fill={backgroundColor}
                fillRule="evenodd"
                xlinkHref="#badge-banner"
              />
            </g>
            <path
              d="M83.3307829,9.69918467 C84.4025385,9.9330547 85.1666667,10.8819008 85.1666667,11.9788763 L85.1666667,81.0681637 C85.1666667,81.9069506 84.7164528,82.6811947 83.9874575,83.0960793 L46.6541241,104.343167 C45.9385902,104.75039 45.0614098,104.75039 44.3458759,104.343167 L7.01254253,83.0960793 C6.28354722,82.6811947 5.83333333,81.9069506 5.83333333,81.0681637 L5.83333333,13.1055477 C5.83333333,12.03352 6.56382291,11.0994231 7.60424213,10.8410215 C20.2415362,7.70238519 32.8734555,6.03913654 45.5,5.85127553 C58.1049046,5.66373648 70.7151656,6.94637286 83.3307829,9.69918467 Z M81.3087902,12.6070143 C69.3790612,10.1030436 57.4604054,8.94035371 45.5485969,9.11758069 C33.6151115,9.29513019 21.6735463,10.8177034 9.71987534,13.6870163 L9.1,13.838 L9.1,80.525 L45.5,101.241 L81.9,80.524 L81.9,12.733 L81.3087902,12.6070143 Z"
              id="Rectangle-Copy-36"
              fill={foregroundColor}
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
            <g transform="translate(23.000000, 27.000000)">{children}</g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Banner.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
  children: PropTypes.node,
};

export default Banner;
